import ForecastAnalysis from "./ForecastAnalysis";
import ForecastDecomposition from "./ForecastDecomposition";
import ClusterCard from "./Clustercard/clusterCard";
import BacktestingResults from "./BacktestingResults";
import ForecastAnalysisFilter from "../../components/ForecastAnalysisFilter/ForecastAnalysisFilter";
import { useEffect, useState } from "react";
import { PageLoader } from "../../baseComponent";
import TimeCardComponent from "./Timecard/TimeCardComponent";
import Sector from "../../baseComponent/Sector/Sector";
import { useDispatch, useSelector } from 'react-redux';
import { resultVisualisationFilterExperimentaionApi } from '../../api/forecastPageApi';
import { RootState } from '../../store/store';
import { setExperimentId } from '../../store/resultVisualizationExperimentation';
import { useOktaAuth } from '@okta/okta-react';

export const StatisticalForecastAnalysis = () => {
  const [showPageLoader, setShowPageLoader] = useState<boolean>(false);
  const pageLoaderHandler = (loadingState: boolean): void => {
    setShowPageLoader(loadingState);
  };

  const dispatch = useDispatch();
  const { authState } = useOktaAuth();
  const currentSectorData = useSelector((state: RootState) => state.user.currentSector);
  const userData = useSelector((state: RootState) => state.user);


  

  const filter = useSelector(
    (state: RootState) => state.resultVisualizationFilter
  );
  
  
  const expermentationPayload = {
    shortTermMidTermCode: filter?.term.toString(),
    sector: currentSectorData?.sector,
    market: currentSectorData?.market,
  };

  useEffect(() => {
   if(currentSectorData?.sector !== undefined && userData?.sections?.forecastAnalysis?.table?.lagDropdown === true && currentSectorData?.market !== undefined) { 
    resultVisualisationFilterExperimentaionApi(
        expermentationPayload,
        authState
      ).then((data) => {
        dispatch(setExperimentId(data));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentSectorData, filter]);


  return (
    <div className="p-5">
      <div className="flex justify-between mb-7">
        <span className="text-3xl font-bold">
          Statistical Forecast Analysis
        </span>
        <Sector/>
      </div>
      <div className="mb-5">
        <span className="text-lg font-bold">Select Criteria</span>
      </div>
      <div className="flex space-x-3">
        <div className='flex min-w-[30%] p-2 bg-secondary-bg rounded h-64'>
          <TimeCardComponent lag={false} label="Forecast Date" isDisabled={false} />
        </div>
        <div className="flex-auto max-w-[70%]">
          <ClusterCard />
        </div>
      </div>
      {showPageLoader && <PageLoader />}
      <ForecastAnalysisFilter pageLoadingHandler={pageLoaderHandler} />
      <ForecastAnalysis />
      <BacktestingResults widthColumn="4%" isResultVisulizationPage={false} isExperimentationPage={false} />
      <ForecastDecomposition />
    </div>
  );
};
